module.exports = __webpack_public_path__ + "static/img/dish4.0044db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/dish4.png
// module id = rKbF
// module chunks = 7